import cn from "classnames";

import { ConversationContact } from "../../aiConversations.types";

import styles from "./ConversationItem.module.scss";

interface Props {
  conversation: ConversationContact;
  isActive?: boolean;
  hideChannel?: boolean;
  onClick?: () => void;
}

const ContactAvatar = ({ name, url }: { name: string; url?: string }) => {
  if (url) {
    return <img src={url} alt={name} className={styles.avatar} />;
  }
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return <div className={styles.avatar}>{initials}</div>;
};

const ConversationItem = ({
  conversation,
  isActive,
  hideChannel,
  onClick
}: Props) => {
  return (
    <button
      type="button"
      className={cn(styles.item, { [styles.itemActive]: isActive })}
      onClick={onClick}
    >
      <ContactAvatar name={conversation.name} url={conversation.avatarUrl} />

      <div className={styles.itemBody}>
        <div className={styles.itemHeader}>
          <span className={styles.itemName}>{conversation.name}</span>
          <span className={styles.itemPreview}>{conversation.preview}</span>
        </div>
        {!hideChannel && (
          <span className={styles.channelTag}>{conversation.channel}</span>
        )}
      </div>

      <div className={styles.itemMeta}>
        <span className={styles.itemDate}>{conversation.date}</span>
        {!!conversation.unreadCount && conversation.unreadCount > 0 && (
          <span className={styles.unreadBadge}>{conversation.unreadCount}</span>
        )}
      </div>
    </button>
  );
};

export default ConversationItem;
